module.exports = __webpack_public_path__ + "img/how-we-work-banner-2.0636f7f5.png";